<template>
	<div class="pop">
		<el-tooltip  placement="top" trigger="hover" :content="content" :close-delay="0" width="20px">
			<slot></slot>
		</el-tooltip>
	</div>
</template>

<script>
	export default{
		name:"Popover",
		props:{
			content:{
				type:String
			}
		}
	}
</script>

<style lang="scss" scoped>
</style>
